export const firstLetterExtractor = (str) => {
  const firstLetter = str.split('')[0];
  return firstLetter;
};
